'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LodashService = function LodashService() {
  'ngInject';

  (0, _classCallCheck3.default)(this, LodashService);
  return _lodash2.default;
};

exports.default = LodashService;
;


// WEBPACK FOOTER //
// ./src/app/shared/services/lodash.js